import { cx } from '@linaria/core';
import { Fragment } from 'react';
import { getCaptionValue } from '@pm2/content-engine';
import { pm2ConfigStore } from '@pm2/store';
import { titleCls, spanCls, captionCls } from './styles/Caption.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const PUNCTUATION_REGEX = /[.,!?]\s*$/;
function Caption(props) {
  const audience = pm2ConfigStore.useSelector(state => state.config.theme.targetAudience);
  const captionModel = extractCaptionContent(props.caption);
  const title = props.displayInternalInfoInPlayer ? undefined : captionModel.title;
  const description = props.displayInternalInfoInPlayer ? undefined : captionModel.description;
  const displayCaption = title || description || captionModel.authorOrArtist || captionModel.country || captionModel.duration || captionModel.year || captionModel.copyright;
  if (!displayCaption) {
    return null;
  }
  const caption = [title && /*#__PURE__*/jsx("span", {
    className: cx(titleCls, spanCls),
    dangerouslySetInnerHTML: {
      __html: title
    },
    "data-comma": !PUNCTUATION_REGEX.test(title)
  }, "title"), description && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: description
    },
    "data-comma": !PUNCTUATION_REGEX.test(description)
  }, "description"), captionModel.caption && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: captionModel.caption
    },
    "data-comma": !PUNCTUATION_REGEX.test(captionModel.caption)
  }, "caption"), captionModel.authorOrArtist && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: captionModel.authorOrArtist
    },
    "data-comma": !PUNCTUATION_REGEX.test(captionModel.authorOrArtist)
  }, "authorOrArtist"), captionModel.country && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: captionModel.country
    },
    "data-comma": !PUNCTUATION_REGEX.test(captionModel.country)
  }, "country"), captionModel.duration && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: captionModel.duration
    },
    "data-comma": !PUNCTUATION_REGEX.test(captionModel.duration)
  }, "duration"), captionModel.year && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: captionModel.year
    },
    "data-comma": !PUNCTUATION_REGEX.test(captionModel.year)
  }, "year"), captionModel.copyright && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: "©&nbsp;" + captionModel.copyright
    },
    "data-comma": !PUNCTUATION_REGEX.test(captionModel.copyright)
  }, "copyright")].filter(it => !!it);
  return /*#__PURE__*/jsx("span", {
    className: cx(captionCls),
    "data-audience": audience,
    "data-is-caption": true,
    "data-position": displayCaption,
    "data-scrambled": props.isScrambled,
    children: caption.map((it, index) => /*#__PURE__*/jsxs(Fragment, {
      children: [it, index < caption.length - 1 && (it.props["data-comma"] === true ? ", " : " ")]
    }, index))
  });
}
function extractCaptionContent(caption) {
  return Object.fromEntries(Object.entries(caption).map(([key, property]) => [key, getCaptionValue(property)]));
}

export { Caption };
//# sourceMappingURL=Caption.js.map
